<div nz-row [nzGutter]="[24, 0]">
  <div nz-col [nzXs]="24" [nzSm]="24">
    <nz-select
      style="width: 100%"
      [nzOptions]="codes()"
      [(ngModel)]="selectedCode"
      nzShowSearch
      nzServerSearch
      [nzShowArrow]="false"
      nzPlaceHolder="Zacznij pisać aby wyszukaj kody"
      [nzLoading]="isLoading()"
      (nzOnSearch)="onSearch($event)"
      (nzScrollToBottom)="loadMoreCodes()"
      [nzDropdownRender]="renderTemplate"
    >
    </nz-select>
    <ng-template #renderTemplate>
      @if (isLoading()) {
        <nz-spin />
      }
    </ng-template>
  </div>
</div>
